module.exports = "/explore/client/62a0bfb652ab108a4f4043cac99ba5ce.svg";